module.exports = __webpack_public_path__ + "img/product-2-part-bag-tag.8328d7dc.jpg";